import type { QuotaBlock } from '@/viewmodel/features/quota/hooks/useQuotaBlocks';
import { resetDate } from '@/viewmodel/shared/errors';
import type { TFunction } from 'i18next';

function blockedList(block: QuotaBlock, t: TFunction, language: string): string {
  const items = block.blocked.map((action) => t(`quotaBanner.blocked.${action}`));
  return new Intl.ListFormat(language, { type: 'conjunction' }).format(items);
}

export function quotaBannerText(block: QuotaBlock, t: TFunction, language: string): string {
  const values = {
    blocked: blockedList(block, t, language),
    used: block.usedGb,
    limit: block.limitGb,
  };
  if (block.line === 'storage') return t('quotaBanner.storage', values);

  return t('quotaBanner.processing', { ...values, date: resetDate(block.resetsAt, t) });
}
